import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { tap } from 'rxjs/operators';
import { AccountService } from '../account.service';
import { Account } from '../models/account';
import { Headset } from '../models/headset';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.css']
})
export class AccountDetailsComponent implements OnInit {

  selectedAccount: Account;
  headsets: Headset[] = [];
  accounts: Account[] = [];

  constructor(
    private accountService: AccountService,
    private snackbar: MatSnackBar,
  ) { }

  ngOnInit() {
  }

  changeAccount(newAccount: Account) {
    this.selectedAccount = newAccount;
    this.accountService.findHeadsetsForAccount(newAccount.id).pipe(
      tap(x => this.headsets = x),
    ).subscribe(x => { console.log('got headsets', x); });
  }

}



// WEBPACK FOOTER //
// ./src/app/account-details/account-details.component.ts